import L from 'leaflet';
import classNames from 'classnames';
import { GeojsonProperties, GeojsonPropertiesTypeEnum } from 'graphql-common';
import { SitePointerShape } from '@lib/components/Map/enums';
import { ChipTypes } from '@lib/components/Chip/Chip';
import chipStyles from '@lib/components/Chip/Chip.module.scss';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import icons from './icons';
import styles from '../Map.module.scss';

export default function getMarker({
  color,
  icon,
  pointCount,
  shape = SitePointerShape.Circle,
  type,
}: GeojsonProperties) {
  const pointCountValue = pointCount || 0;
  const isCluster = type === GeojsonPropertiesTypeEnum.Cluster;

  // `color` is a `ColorEnum` (site pins) or the legend's bare name; both resolve
  // to the `chip-*` SCSS class. Falls back to the same default as an unset
  // pointer (Map.tsx's pointerDefaultProps), not colorToChipType's generic gray.
  const colorValue = colorToChipType(color, ChipTypes.chipAquamarine);
  const baseSvg = (() => {
    switch (shape) {
      case SitePointerShape.Pentagon:
        return icons.pentagon;
      case SitePointerShape.Square:
        return icons.square;
      case SitePointerShape.Star:
        return icons.star;
      case SitePointerShape.Circle:
      default:
        return icons.circle;
    }
  })();

  let html = baseSvg;

  if (isCluster) {
    let size = 40;
    if (pointCountValue > 3 && pointCountValue < 10) {
      size = 64;
    } else if (pointCountValue >= 10) {
      size = 80;
    }
    html = `
      <div style="position: relative; width: ${size}px; height: ${size}px;">
        ${icons.cluster}
        <div class="${styles.markerClusterCounter}">
          ${pointCount}
        </div>
      </div>
    `;
    return L.divIcon({
      className: classNames(
        chipStyles.chipColorClass,
        chipStyles[ChipTypes.chipBlue],
      ),
      html,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  }

  if (icon) {
    html = `
      <div class="${styles.markerIconWrap}">
        ${baseSvg}
        <div class="${classNames(styles.markerImageWrap, { [styles.markerImageWrapSmall]: shape === SitePointerShape.Star })}">
          <img src="${icon}" alt="Custom icon" onerror="this.style.display='none';" />
        </div>
      </div>
    `;
  }

  return L.divIcon({
    className: classNames(chipStyles.chipColorClass, chipStyles[colorValue]),
    html,
    iconSize: [60, 64],
    iconAnchor: [30, 64],
  });
}
